import ServerGridConfig from "../../../config/ServerGridConfig";
import { AgGridReact } from "@ag-grid-community/react";
import { AllModules } from "@ag-grid-enterprise/all-modules";
import useStore from "../../../store";
import { observer } from "mobx-react";
import { vsmCommon } from "../../../config/messages";
import { CurrencyFormat, DateComparator } from "../../../utils/GlobalFunction";
import Unauthorized from "../../commonpage/Unauthorized";
import BreadcrumbComponent from "../../../component/BreadcrumbComponent";
import RecordPerPage from "../../../component/RecordPerPage";
import { BreadcrumbConfig } from "../../../config/BreadcrumbConfig";
import { PageHeader, DatePicker, Button, Form } from "antd";
import moment from "moment";
import { useEffect } from "react";
const { RangePicker } = DatePicker;
const dateFormat = "DD/MM/YYYY";

const DSAReportListComponent = observer((props) => {
	const [form] = Form.useForm();
	const {
		DSAReportStore: { list_data, setupGrid, setPageSize, per_page, setListCustomDate, fromDate, toDate  },
		AUTH: { checkPrivileges },
	} = useStore();

	useEffect(() => {
		let datecompleted = []
		datecompleted.push(moment().subtract(1, "month"), moment().subtract(1, "days"))
		form.setFieldsValue({
			date_completed: datecompleted
		})
	}, [form])


	const gridOptions = {
		columnDefs: [
			{
				headerName: "# ID",
				field: "srno",
				filter: "agNumberColumnFilter",
				pinned: "left",
				minWidth: 120,
				width: 120,
			},
			{
				headerName: "Customer Name",
				field: "booking_customer.full_name",
				valueGetter: (params) => (params.data && params.data?.booking_customer?.changed_name) ? params.data?.booking_customer?.changed_name : params.data?.booking_customer?.full_name
			},
			{
				headerName: "Sales Consultant",
				field: "sales_consultant.name",
				valueGetter: (params) => (params.data && params.data.sales_consultant) ? params.data.sales_consultant?.name : "N/A",
			},
			{
				headerName: "Location Name",
				field: "location.name",
				valueGetter: (params) => (params.data && params.data.location) ? params.data.location?.name : "N/A",
			},
			{
				headerName: "Chassis Number",
				field: "booking_model.chassis_no",
				filter: "agNumberColumnFilter",
			},
			{
				headerName: "Model",
				field: "booking_model.model.name",
				valueGetter: (params) => (params.data && params.data.booking_model) ? params.data.booking_model?.model?.name : "N/A",
			},
			{
				headerName: "Name of DSA",
				field: "finance_offer.dsa.name",
				valueGetter: (params) => (params.data && params.data.finance_offer) ? params.data.finance_offer?.dsa?.name : "N/A",
			},
			{
				headerName: "Amount to be paid",
				field: "finance_offer.dsa_comm",
				filter: "agNumberColumnFilter",
				cellRendererFramework: function (params) {
					return <CurrencyFormat value={params.data.finance_offer?.dsa_comm} />
				},
			},
			{
				headerName: "Pan of DSA",
				field: "finance_offer.dsa.pan_card",
				valueGetter: (params) => (params.data && params.data.finance_offer) ? params.data.finance_offer?.dsa?.pan_card : "N/A",
			},
			{
				headerName: "Zform Date",
				field: "date_completed",
				filter: "agDateColumnFilter",
				filterParams: {
					buttons: ['reset'],
					inRangeInclusive: true,
					suppressAndOrCondition: true,
					comparator: DateComparator,
					browserDatePicker: true
				},
			},
			{
				headerName: "Order No",
				field: "co_no",
				filter: "agNumberColumnFilter",
			},
			{
				headerName: "Remarks",
				field: "finance_offer.remarks_sc",
				valueGetter: (params) => (params.data && params.data.finance_offer) ? params.data.finance_offer?.remarks_sc : "N/A",
			},		
			
		],
	};
	ServerGridConfig.options.paginationPageSize = 5000
	ServerGridConfig.options.cacheBlockSize = 5000
	return (
		<>
			{!checkPrivileges("#54007#") ? (
				<Unauthorized />
			) : (
				<PageHeader
					title={BreadcrumbConfig.DSAReport.title}
					className="tableAreaSec"
					extra={
						<BreadcrumbComponent items={BreadcrumbConfig.DSAReport.path} />
					}
				>
					<div className="listCountNew">
						<Form
							form={form}
							id="editPasswordForm"
							layout="vertical"
							className="defaultdatefliter"
						>
							<Form.Item
								name="date_completed">
								<RangePicker
									defaultValue={[moment(fromDate), moment(toDate)]}
									format={dateFormat}
									allowClear={false}

								//name="date_completed"
								//onChange={(date, dateString) => setListCustomDate(dateString)}
								/>
							</Form.Item>
							<Button
								key="1"
								form="editPasswordForm"
								htmlType="submit"
								type="primary"
								onClick={() => {
									if (form.getFieldsValue('date_completed')) {
										setListCustomDate([form.getFieldsValue('date_completed')])

									} else {
										setListCustomDate([moment().subtract(1, "month"), moment().subtract(1, "days")])
									}
								}}
							>
								Filter
							</Button>
						</Form>
						{/* {AUTH.checkPrivileges("#6305#") && ( */}
						<RecordPerPage
							key="2"
							style={{ width: "150px" }}
							defaultValue={per_page + " per page"}
							onChange={setPageSize}
						/>

					</div>
					<div className="ag-theme-alpine grid_wrapper">
						<AgGridReact
							rowHeight={ServerGridConfig.rowHeight}
							headerHeight={ServerGridConfig.headerHeight}
							rowData={list_data}
							modules={AllModules}
							columnDefs={gridOptions.columnDefs}
							defaultColDef={ServerGridConfig.defaultColDef}
							columnTypes={ServerGridConfig.columnTypes}
							overlayNoRowsTemplate={vsmCommon.noRecord}
							onGridReady={setupGrid}
							gridOptions={ServerGridConfig.options}
						/>
					</div>
				</PageHeader>
			)}
		</>
	);
});

export default DSAReportListComponent;
